module.exports = __webpack_public_path__ + "static/media/students-icon-4.a6da1414.svg";